const DEFAULT_START = 0
const DEFAULT_LIMIT = 20
const DEFAULT_ROW_HEIGHT = 35
const DEFAULT_ROW_HANDLE_WIDTH = 50
const DEFAULT_RIGHT_ROW_HANDLE_WIDTH = 85
const ROW_HANDLE_MIN_WIDTH = 30
const ROW_HANDLE_MAX_WIDTH = 200
const DEFAULT_COLUMN_WIDTH = 250
const COLUMN_MIN_WIDTH = 30
const COLUMN_MAX_WIDTH = 1200
const COLUMN_RESIZE_HANDLE_WIDTH = 4
const COLUMN_BTN_MENU_WIDTH_OFFSET = 50

export {
    COLUMN_BTN_MENU_WIDTH_OFFSET,
    DEFAULT_START,
    DEFAULT_LIMIT,
    DEFAULT_ROW_HEIGHT,
    DEFAULT_RIGHT_ROW_HANDLE_WIDTH,
    DEFAULT_ROW_HANDLE_WIDTH,
    ROW_HANDLE_MIN_WIDTH,
    ROW_HANDLE_MAX_WIDTH,
    DEFAULT_COLUMN_WIDTH,
    COLUMN_MIN_WIDTH,
    COLUMN_MAX_WIDTH,
    COLUMN_RESIZE_HANDLE_WIDTH,
}